import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[hsl(var(--muted))] px-4">
      <div className="w-full max-w-md bg-card rounded-[2rem] border border-border p-8 shadow-lg">
        <div className="flex items-center gap-3 mb-6">
          <img src="/esprit-logo.png" alt="Esprit" className="h-10 w-auto" />
          <div className="border-l border-border pl-3">
            <h1 className="font-heading font-bold text-xl text-primary leading-none">Admin Portal</h1>
            <p className="text-sm text-muted-foreground">Staff dashboard login</p>
          </div>
        </div>

        <form data-testid="admin-login-form" onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="email" className="text-base">Email</Label>
            <Input id="email" type="email" data-testid="admin-email-input" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-13 text-lg mt-1.5 py-3" />
          </div>
          <div>
            <Label htmlFor="password" className="text-base">Password</Label>
            <Input id="password" type="password" data-testid="admin-password-input" required value={password} onChange={(e) => setPassword(e.target.value)} className="h-13 text-lg mt-1.5 py-3" />
          </div>
          {error && <p data-testid="admin-login-error" className="text-destructive text-sm">{error}</p>}
          <button type="submit" data-testid="admin-login-btn" disabled={loading}
            className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-primary hover:bg-primary/90 text-primary-foreground h-14 text-lg font-bold transition-colors disabled:opacity-60">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <Lock className="w-5 h-5" />} Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
